export default class File {
  /** @type {string} */ Nombre = null
  /** @type {string} */ Mime = null
  /** @type {string} */ contenidoB64 = null
}
